export const onlyDigits = (v: string | null | undefined) =>
  String(v || "").replace(/\D/g, "");


export function pickFirstNonEmptyString(
  ...candidates: unknown[]
): string | null {
  for (const c of candidates) {
    if (c != null && String(c).trim() !== "") return String(c);
  }
  return null;
}


export function normalizeV2ListItemDates(item: any) {
  return {
    adequacaoSolicitadaEm: pickFirstNonEmptyString(
      item?.adequacaoSolicitadaEm,
      item?.AdequacaoSolicitadaEm,
    ),
    adequacaoRealizadaEm: pickFirstNonEmptyString(
      item?.adequacaoRealizadaEm,
      item?.AdequacaoRealizadaEm,
    ),
    analiseConcluidaEm: pickFirstNonEmptyString(
      item?.analiseConcluidaEm,
      item?.AnaliseConcluidaEm,
    ),
    enviadoPeloSindicatoEm: pickFirstNonEmptyString(
      item?.enviadoPeloSindicatoEm,
      item?.EnviadoPeloSindicatoEm,
    ),
    atualizadoPeloSindicatoEm: pickFirstNonEmptyString(
      item?.atualizadoPeloSindicatoEm,
      item?.AtualizadoPeloSindicatoEm,
    ),
  };
}

type NormalizeSituacaoNomeFn = (s: string | null | undefined) => string;

function normKeySituacao(s: string): string {
  return String(s || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}


export function normalizeSituacaoNomeApiMeritocracia(
  situacao: string | null | undefined,
): string {
  if (situacao == null || String(situacao).trim() === "") return "-";
  const k = normKeySituacao(situacao);

  if (k === "documentacao pendente") return "Documentação Pendente";
  if (k === "documentacao enviada") return "Documentação Enviada";
  if (k === "analise pendente") return "Análise Pendente";
  if (k === "analise em andamento") return "Análise em Andamento";
  if (k === "adequacao pendente") return "Adequação Pendente";
  if (k === "analise concluida") return "Análise Concluída";
  if (k === "inapto") return "Inapto";

  return String(situacao).trim();
}

export function normalizeSituacaoNomeSindicato(
  situacao: string | null | undefined,
): string {
  if (situacao == null || String(situacao).trim() === "") return "-";
  const k = normKeySituacao(situacao);

  if (k === "analise pendente") return "Documentação Enviada";
  if (k === "analise em andamento") return "Documentação Enviada";

  return normalizeSituacaoNomeApiMeritocracia(situacao);
}


export function pickV2StatusSolicitacaoNomeApi(item: any): string | null {
  const st = item?.statusSolicitacaoAvaliacao ?? item?.StatusSolicitacaoAvaliacao;
  if (st && typeof st === "object") {
    const nome = pickFirstNonEmptyString(
      (st as { nome?: string }).nome,
      (st as { Nome?: string }).Nome,
    );
    if (nome) return nome;
  }
  return pickFirstNonEmptyString(
    item?.statusSolicitacaoNome,
    item?.StatusSolicitacaoNome,
    item?.situacaoNome,
    item?.SituacaoNome,
  );
}


export function resolveV2SituacaoParaLista(
  item: any,
  normalizeSituacaoNome: NormalizeSituacaoNomeFn,
): string {
  const nomeApi = pickV2StatusSolicitacaoNomeApi(item);
  if (nomeApi != null && String(nomeApi).trim() !== "") {
    return normalizeSituacaoNome(nomeApi);
  }
  return "-";
}


export function rowSituacaoMatchesSelectedFilters(
  situacaoRow: string | undefined,
  selectedSituation: string[],
  _allSituationLabels: readonly string[],
): boolean {
  if (selectedSituation.length === 0) return false;

  const situacao = (situacaoRow ?? "").toLowerCase().trim();
  const selectedNorm = selectedSituation.map((s) => s.toLowerCase().trim());
  return selectedNorm.includes(situacao);
}
